<template lang="html">
  <div class="overlayt">
    <div class="popupt usl" >
      <div class="term" @click="preventClose" >
        <h2 style="text-align:center">Korisnički uslovi</h2>
        <br>
      </div>
      <button type="button" name="button" @click="close($event)" >Zatvori</button>
      <div class="pol" @click="preventClose">

      <br>
      <h2>Uslovi korišćenja i prodaje</h2>
      <br>
<p>Opšti uslovi</p>
<p>Na osnovu odredbe 13. i 27. Zakona o zaštiti potrošača privredno društvo Beauty Core d.o.o. svoje kupce, koji robu kupuju putem internet sajta www.beautycore.rs, obaveštava:</p>
<br>
<ul>
  <li>•	 da je Virginia d.o.o. privredno društvo sa ograničenom odgovornošću sa registrovanim sedištem u Beogradu, Novi Beograd, u ulici Surčinski put 21, sa matičnim brojem: 17239546, PIB: 100291517, brojem telefona: 0112269043, mejl adresom:office@virginia.rs. Za više podataka vidite stranu
•	O NAMA
</li>
  <li>da se osnovna obeležja svih proizvoda iz proizvodnog asortimana Virginia d.o.o. mogu pronaći na sajtu www.virginia.rs</li>
  <li>•	da proizvodi koji se prodaju putem internet sajta www.virginia.rs poseduju svojstva potrebna za redovnu upotrebu te vrste proizvoda u skladu sa njihovom namenom</li>
  <li>da je prodajna cena proizvoda naznačena uz svaki artikal</li>
  <li>da su sve cene izražene sa uračunatim PDV-om</li>
  <li>da kupljene proizvode isporučujemo putem kurirske službe, na način kako je to definisano na strani USLOVI ISPORUKE</li>
  <li>da kupac proizvode koje kupuje putem internet prodavnice www.virginia.rs može platiti pouzećem, gotovinski u trenutku isporuke, kao i istaknutim platnim karticama u trenutku kupovine na sajtu; za vište podataka vidite stranu PLAĆANJE</li>
  <li>da je kupac prilikom kreiranja porudžbenice pritiskom na dugme POTVRDI poslao ponudu prodavcu i da je u trenutku prijema potvrde porudžbine preuzeo obavezu plaćanja naručenog proizvoda</li>
  <li>da je sajt www.virginia.rs dužan da isporuči proizvode saobrazne ugovoru</li>
  <li>da u slučaju prijema proizvoda kupac isti ne želi da zadrži, ima pravo na odustanak ugovora i povraćaj sredstava u visini plaćene kupoprodajne cene za predmetni proizvod, u roku od 14 dana na način kako je to definisano na strani PRAVO NA ODUSTAJANJE</li>
  <li>da za proizvode koji su poručeni putem online prodavnice kupac ima pravo da izjavi reklamaciju na proizvod, na način koji je definisan za robu kupljenu putem online prodavnice. Način i postupak izjavljivanja reklamacije možete pronaći na strani REKLAMACIJE</li>
</ul>
<br>
<h2>Rok isporuke</h2>
<br>
<p>U zavisnosti od raspoložive količine poručenih proizvoda, očekivani rok isporuke je do 120h (vikend ne ulazi u satnicu isporuke).</p>
<br>
<p>Nakon obrade porudžbine, bićete obavešteni o statusu Vaše porudžbine putem email-a.</p>
<br>
<h2>Preuzimanje pošiljke</h2>
<br>
<p>Naručene proizvode Vam šaljemo kurirskom službom Aks koja isporuku vrši na teritoriji Republike Srbije. Radno vreme kurirske službe je svakog radnog dana od 8h do 17h.</p>
<br>
<p>Molimo Vas da u tom periodu obezbedite da na adresi bude osoba koja može preuzeti pošiljku. Prilikom preuzimanja pošiljke potrebno je da vizuelno pregledate paket da slučajno ne postoje neka vidna oštećenja. Ukoliko primetite da je transportna kutija značajno oštećena i posumnjate da je proizvod možda oštećen, odbijte prijem pošiljke i odmah nas obavestite, pozivom na broj 0112269043 ili putem e-mail-a office@virginia.rs. Ukoliko je pošiljka naizgled bez oštećenja slobodno preuzmite pošiljku i potpišite kuriru adresnicu. Kurir svaku pošiljku pokušava da uruči u dva navrata, nakon čega će se pošiljka vratiti nama.</p>
<br>
<h2>Cena isporuke</h2>
<br>
<p>Isporuka na naznacenu adresu se formira u zavisnosti od odabrane opcije porudžbine.</p>
<br>
<h2>NAPOMENA:</h2>
<br>
<p>Potvrdom porudžbine, klikom na dugme PORUČI, saglasni ste sa uslovima isporuke.</p>
</div>

    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
export default {
  data(){
    return{


    }
  },
  computed:{
    ...mapGetters([
        'showuslovi'

    ]),


  },
methods:{
  close(e){
    this.setuslovi(!this.showuslovi);
      e.stopPropagation()
  },
  preventClose (e) {
      			e.stopPropagation()
      		},
          ...mapMutations([

  					'setuslovi'
  			]),

},


  mounted(){


  }
}
</script>

<style lang="css">

 .usl {
    overflow-y: scroll;
    position: relative;
    height: 80%;
    width: 60%;
    top: 100px;
    left: 20%;
    padding: 40px 10px 10px;
    background: white;
    z-index: 1000;
    text-align: center;
    border: 2px solid var(--narandzasta);
}
</style>



// WEBPACK FOOTER //
// src/components/uslovi.vue